import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "summary" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  ref: "summary",
  class: "content"
}
const _hoisted_4 = { class: "row-vcenter" }
const _hoisted_5 = { class: "doc-title" }
const _hoisted_6 = { class: "block-title" }
const _hoisted_7 = { class: "ui suffixed list" }
const _hoisted_8 = {
  class: "opt-title",
  nowrap: ""
}
const _hoisted_9 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Avatar = _resolveComponent("Avatar")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString($options.store.summary_title || 'Summary'), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        ($options.store.avatar_id)
          ? (_openBlock(), _createBlock(_component_Avatar, {
              key: 0,
              class: "avatar",
              image_id: $options.store.avatar_id,
              name: $options.store.name,
              width: "5.6rem",
              height: "5.6rem"
            }, null, 8 /* PROPS */, ["image_id", "name"]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("b", _hoisted_5, _toDisplayString($options.doc_title), 1 /* TEXT */)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.schema, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.value,
          class: "block"
        }, [
          _createElementVNode("b", _hoisted_6, _toDisplayString(item.title), 1 /* TEXT */),
          _createElementVNode("ol", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getPrintableFields(item.opts), (opt) => {
              return (_openBlock(), _createElementBlock("li", {
                key: opt.value
              }, [
                _createElementVNode("b", _hoisted_8, _toDisplayString(opt.title) + ":", 1 /* TEXT */),
                _createElementVNode("span", {
                  innerHTML: $options.transformData($options.store[opt.field], opt.type, opt)
                }, null, 8 /* PROPS */, _hoisted_9)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 512 /* NEED_PATCH */)
  ]))
}